import React, {useState} from 'react';
import {
  Fab,
} from '@material-ui/core';
import TargetIcon from '@mui/icons-material/ControlCamera';
import TargetModal from './TargetModal';

export default function Target({
  setShowInfo,
  setShowStopButton,
  targetName,
  setTargetName,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{margin:"1rem"}}>
      <Fab onClick={() => setIsOpen(true)} style={{zIndex:1}}>
        <TargetIcon />
      </Fab>
      <TargetModal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        setShowInfo={setShowInfo}
        setShowStopButton={setShowStopButton}
        targetName={targetName}
        setTargetName={setTargetName}
      />
    </div>
  );
}